import { Configuration } from "msal";

export const msalConfig = {
    auth: {
        authority: "https://login.microsoftonline.com/",
        clientId: "",
        redirectUri: ""
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {},
    framework: {}
} as Configuration;

export const loginRequest = {
    scopes: ["openid", "profile", "User.Read"]
};
